import SuperRepository from '../superRepository'

export default new class CurrencyRepository extends SuperRepository {
    baseUri () {
        return 'currency'
    }
}